export default {
    emailEditor: {
        tabs: {
            add: "Add",
            settings: "Settings",
            blocks: "Blocks",
            modules: "Modules",
            layout: "Layout",
        },
        add: {
            sections: "Sections",
            rows: "Rows",
            showMore: "Show more",
            showLess: "Show less",
        },
        defaults: {
            imageAlt: "Image",
            textContent: "Your text here...",
        },
        topbar: {
            undo: "Undo",
            redo: "Redo",
            clearSelection: "Clear selection",
            preview: "Preview",
            backToEditor: "Back to editor",
            copyHtml: "Copy HTML",
            templateGallery: "Template gallery",
            saveAsTemplate: "Save as template",
            close: "Close",
            save: "Save",
            settings: "Settings",
            emailSettings: "Email settings",
        },
        templateGallery: {
            title: "Template gallery",
            subtitle: "Choose a template to start editing.",
            loading: "Loading...",
            noScreenshot: "No screenshot",
            blankModel: "Blank model",
            place: "From this place",
            global: "Global",
            close: "Close",
            startBlank: "Start blank",
        },
        saveAsset: {
            editTitle: "Edit {0}",
            saveAsTitle: "Save as {0}",
            editSubtitle: "Update name/visibility.",
            createSubtitle: "Give it a name and choose visibility.",
            name: "Name",
            namePlaceholder: "Ex.: Summer Promotion",
            visibility: "Visibility",
            placeVisibility: "Visible only to this place",
            globalVisibility: "Visible to everyone",
            placeHint: "Visible only to this place.",
            delete: "Delete",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving…",
            kindModule: "module",
            kindTemplate: "template",
        },
        ai: {
            badge: "Kevi AI",
            hint: "Describe what you want to change in the email. Use Enter for new lines. Send: Ctrl+Enter / Cmd+Enter.",
            placeholder: "Ex.: Change the title to 'Summer Promotion', make the button green, and move the image block upward.",
            ariaLabel: "Edit email with AI",
            apply: "Apply with AI",
            applying: "Applying…",
            loadingAria: "Generating with AI",
            loadingSubtitle: "This may take up to 1 minute.",
            loadingSentenceAnalyze: "Analyzing your request…",
            loadingSentenceStructure: "Understanding the email structure…",
            loadingSentenceApply: "Applying layout changes…",
            loadingSentenceAdjust: "Adjusting styles and spacing…",
            loadingSentenceReview: "Reviewing the final JSON…",
            loadingFallback: "Generating changes…",
        },
        modules: {
            loading: "Loading modules...",
            empty: "No modules available.",
        },
        mobile: {
            insertHere: "Insert here",
            moveRowHere: "Move row here",
            moveSectionHere: "Move section here",
            moveColumnHere: "Move column here",
            moveBlockHere: "Move block here",
        },
        titles: {
            block: "Block: {type}",
            rowSettings: "Row settings",
            columnSettings: "Column settings",
            containerSettings: "Container settings",
            sectionTag: "(section)",
            emailDesign: "Email design",
        },
        common: {
            align: "Alignment",
            top: "Top",
            middle: "Middle",
            bottom: "Bottom",
            left: "Left",
            center: "Center",
            right: "Right",
            axisY: "Y",
            axisX: "X",
            unitPercent: "%",
            unitPx: "px",
            width: "Width",
            widthAuto: "Auto",
            widthFilled: "Filled",
            text: "Text",
            link: "Link",
            linkOptional: "Link (optional)",
            background: "Background",
            color: "Color",
            thickness: "Thickness",
            heightPx: "Height (px)",
            widthPx: "Width (px)",
            padding: "Padding",
            margin: "Margin",
            radius: "Border radius",
            borderRadiusSquare: "Square",
            borderRadiusSmall: "Small (4px)",
            borderRadiusMedium: "Medium (8px)",
            borderRadiusLarge: "Large (16px)",
            borderRadiusXLarge: "Extra large (32px)",
            borderRadiusCircle: "Circle",
            paddingHorizontal: "Horizontal padding",
            paddingVertical: "Vertical padding",
            corners: "Corners",
            display: "Display",
            displayBlock: "Block",
            displayInline: "Inline",
            urlPlaceholder: "https://...",
        },
        borderSettings: {
            label: "Border",
            color: "Border color",
            enabled: "Enabled",
            disabled: "Disabled",
            sides: "Sides",
            width: "Thickness",
            style: "Style",
        },
        image: {
            url: "Image URL",
            alt: "Alternative text",
            chooseFile: "Choose file",
            display: "Display",
            displayBlock: "Block",
            displayInline: "Inline",
            widthPx: "Width (px)",
            borderRadiusPx: "Border radius",
            objectFit: "Object fit",
            objectFitCover: "Cover",
            objectFitContain: "Contain",
            objectFitFill: "Fill",
            objectFitNone: "None",
            objectFitScaleDown: "Scale down",
            aspectRatio: "Aspect ratio",
            aspectRatioAuto: "Auto",
            aspectRatioSquare: "Square (1:1)",
            aspectRatio16x9: "Widescreen (16:9)",
            aspectRatio9x16: "Vertical (9:16)",
            aspectRatio4x3: "Standard (4:3)",
            aspectRatio3x4: "Portrait (3:4)",
            aspectRatio3x2: "Photo (3:2)",
            aspectRatio2x3: "Portrait (2:3)",
        },
        margins: {
            title: "Spacing",
            topPx: "Top (px)",
            bottomPx: "Bottom (px)",
            leftPx: "Left (px)",
            rightPx: "Right (px)",
            defaults: "Default: top 8px, left/right 0px.",
        },
        row: {
            columns: "Columns",
            columnSingular: "column",
            columnPlural: "columns",
            align: "Row alignment",
            mobileOrientation: {
                label: "Mobile content orientation",
                leftOnTop: "Left on top",
                rightOnTop: "Right on top",
                keepColumns: "Keep columns",
            },
            mobileOrientationLeftOnTop: "Left on top",
            mobileOrientationRightOnTop: "Right on top",
            mobileOrientationKeepColumns: "Keep columns",
            paddingTop: "Top padding",
            paddingBottom: "Bottom padding",
            paddingLeft: "Left padding",
            paddingRight: "Right padding",
            columnGap: "Column gap",
            background: "Row background",
            backgroundHelp: "Set to white to simulate separate bands.",
            marginHelp: "Space outside the row border. Use this to inset a bordered row from the email edge.",
        },
        button: {
            canvasHint:
                "Tip: you can edit and format directly on the button in the canvas.",
        },
        column: {
            controls: "Column controls",
            verticalAlignLabel: "Vertical alignment",
            verticalAlignHelp:
                "Controls the vertical alignment of the content inside the column.",
            backgroundHelp:
                "Applied only within this column (does not affect other columns in the row).",
        },
        emailDesign: {
            background: "Background",
            body: "Content background",
            emailWidthLabel: "Email width",
            widthPx: "Width (px)",
            topSpacingPx: "Top spacing (px)",
            borderRadiusPx: "Border radius",
            mobilePaddingPx: "Mobile padding (px)",
            fontFamily: "Font family",
            fontHelveticaArial: "Helvetica / Arial",
            fontArial: "Arial",
            fontVerdana: "Verdana",
            fontTahoma: "Tahoma",
            fontTrebuchetMs: "Trebuchet MS",
            fontGeorgia: "Georgia",
            fontTimesNewRoman: "Times New Roman",
            fontCourierNew: "Courier New",
            text: "Text",
            links: "Links",
            buttonBackground: "Button background",
            buttonText: "Button text",
        },
        actions: {
            deleteBlock: "Delete block",
            deleteRow: "Delete row",
            deleteContainer: "Delete container",
            duplicateColumn: "Duplicate column",
        },
        settingsTabs: {
            block: "Block",
            column: "Column",
            row: "Row",
            section: "Section",
        },
        settingsEmpty: {
            block: "Select a block to edit.",
            column: "Select a column to edit.",
            row: "Select a row to edit.",
            section: "Select a section to edit.",
        },
        backgroundPicker: {
            color: "Color",
            image: "Image",
            choose: "Choose image",
            remove: "Remove",
            empty: "No image",
            size: "Size",
            sizeCover: "Cover",
            sizeContain: "Contain",
            sizeCustomWidth: "Custom (width)",
            repeat: "Repeat",
            repeatNoRepeat: "Do not repeat",
            repeatRepeat: "Repeat",
            repeatRepeatX: "Repeat X",
            repeatRepeatY: "Repeat Y",
            position: "Position",
            positionLeftTop: "Left / Top",
            positionCenterTop: "Center / Top",
            positionRightTop: "Right / Top",
            positionLeftCenter: "Left / Center",
            positionCenterCenter: "Center",
            positionRightCenter: "Right / Center",
            positionLeftBottom: "Left / Bottom",
            positionCenterBottom: "Center / Bottom",
            positionRightBottom: "Right / Bottom",
        },
        mobileInsertBar: {
            add: "Add",
            chooseOther: "Choose another element",
            cancelInsertion: "Cancel insertion",
            insertContent: "Insert content",
            mode: "Mode",
            close: "Close",
            selectMode: "Select mode",
            cancel: "Cancel",
            elements: "Elements",
            row: "Row {0}",
            loading: "Loading…",
            noModules: "No modules",
            module: "Module",
            noPreview: "No preview",
        },
        mobileActionMenu: {
            title: "Actions",
            editSettings: "Edit settings",
        },
        preview: {
            device: "Preview device",
            desktop: "Desktop",
            mobile: "Mobile",
        },
        emptyState: {
            dragBlocksHere: "Drag blocks here",
            dragModulesOrLayoutsHere: "Drag modules or layouts here",
        },
        container: {
            name: "Section name",
            add: "Add section",
            controls: "Container controls",
            personalizationTitle: "Personalization",
            personalizationCreditTooltip:
                "One extra credit will be consumed for each email sent.",
            personalizationCreditAmount: "1 credit",
            personalizationDescription:
                "Describe how Kevi AI should adapt this section for each client.",
            backgroundHelp:
                "Tip: use sections to separate header, body and footer with different backgrounds and paddings.",
            containerSettings: "Section settings",
            contentAreaSettings: "Content area settings",
            border: "Section border",
            contentBackground: "Background",
            bodyBackground: "Content background",
            contentBorder: "Border",
            contentBorderRadius: "Corners",
            paddingHelp: "Space around the content card inside the full-width stripe. It does not inset rows inside the card.",
        },
        tooltips: {
            dragRow: "Drag row",
            dragBlock: "Drag block",
            drag: "Drag",
            duplicate: "Duplicate",
            delete: "Delete",
            edit: "Edit",
            settings: "Settings",
            move: "Move",
            copyStyles: "Copy styles",
            saveAsModule: "Save as module",
            addSectionAbove: "Add section above",
            addSectionBelow: "Add section below",
        },
        prompts: {
            copyHtml: "Copy HTML",
            linkUrl: "Link URL",
            confirmDeleteAsset: "Delete? This action cannot be undone.",
            sendTestEmail: "Which email should receive the test?",
        },
        errors: {
            renderHtmlFailed: "Failed to render HTML",
        },
        notifications: {
            saveError: "Failed to save.",
            generatingScreenshot: "Generating screenshot...",
            savingTemplate: "Saving template...",
            templateSavedGlobal: "Global template saved!",
            templateSaved: "Template saved!",
            selectRowToSaveModule: "Select a row to save as a module.",
            generatingModuleScreenshot: "Generating module screenshot...",
            savingModule: "Saving module...",
            moduleSavedGlobal: "Global module saved!",
            moduleSaved: "Module saved!",
            updated: "Updated!",
            deleted: "Deleted!",
            startBlank: "Starting blank!",
            invalidTemplateNoDoc: "Invalid template (missing doc).",
            templateApplied: "Template applied!",
            invalidModuleNoRow: "Invalid module (missing row).",
            moduleInserted: "Module inserted!",
            saved: "Saved!",
            invalidEmail: "Invalid email.",
            sendingTestEmail: "Sending test to {0}...",
            htmlCopied: "HTML copied!",
            changeTemplateInDevelopment:
                "Template switching is still in development",
            stylePasteBlockHint:
                "Now click another block of the same type to paste the styles.",
            stylePasteRowHint: "Now click another row to paste the styles.",
            stylePasteSectionHint:
                "Now click another section to paste the styles.",
            stylePasteColumnHint:
                "Now click another column to paste the styles.",
            duplicateColumnHint:
                "Now click another column to duplicate here.",
            stylesPasted: "Styles pasted!",
            columnDuplicated: "Column duplicated!",
            styleCopyCancelled: "Style copy cancelled.",
            applyingAi: "Applying AI changes...",
            emailUpdated: "Email updated!",
            aiApplyError: "Failed to apply AI changes.",
        },
        palette: {
            blocks: {
                text: "Text",
                image: "Image",
                button: "Button",
                divider: "Divider",
                spacer: "Spacer",
            },
            rows: {
                oneColumn: "Row: 1 column",
                twoColumns: "Row: 2 columns",
                threeColumns: "Row: 3 columns",
            },
        },
        tiptap: {
            font: "Font",
            bodyFont: "(Body font)",
            fontHelvetica: "Helvetica",
            fontArial: "Arial",
            fontGeorgia: "Georgia",
            fontTimes: "Times",
            lineHeight: "Line height",
            lineHeightShort: "LH",
            textColor: "Text color",
            textBackground: "Text background",
            textGlyph: "A",
            removeBackground: "Remove background",
            bold: "Bold",
            italic: "Italic",
            underline: "Underline",
            strike: "Strikethrough",
            snippets: "Snippets",
            size: "Size",
            link: {
                title: "Text Link",
                close: "Close",
                linkTo: "Link to",
                type: {
                    web: "Web",
                    email: "Email",
                    whatsapp: "WhatsApp",
                    phone: "Phone",
                    unsubscribe: "Unsubscribe",
                },
                web: {
                    url: "URL",
                    placeholder: "Enter URL here",
                    invalid:
                        "Please enter a URL starting with http:// or https://",
                },
                email: {
                    address: "Email",
                    placeholder: "email@company.com",
                    subject: "Message subject",
                    body: "Message body",
                },
                whatsapp: {
                    phone: "Phone (with area code)",
                    phonePlaceholder: "(##) #####-####",
                    message: "Message",
                },
                phone: {
                    number: "Phone",
                    placeholder: "(##) #####-####",
                },
                unsubscribeHint:
                    "This link will be replaced automatically when the email is sent.",
                save: "Save",
                remove: "Remove",
            },
        },
    },
};
